import { __assign, __extends } from "tslib";
import React from 'react';
import { Platform, View } from 'react-native';
import moment from 'moment';
import FadeLoader from "../Spinners/FadeSpinner/FadeSpinner";
import { PnmacCard, PnmacCardActions, PnmacCardContent, PnmacCardTitle, PnmacImage, PnmacNavigation, PnmacText, PnmacTitle, PnmacUIButton, PnmacWelcomeLoader } from 'pnmac-universal-components';
import { InfoIcon } from '../Icons';
import { currencyFormatter, genericStatusCheck, getActiveFeatures, paymentStatus, percentFormatter, phazOne } from '../utils.js';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../redux/events/events';
import { textStyle } from '../v2/theme';
var styles = {
  card: {
    padding: 10,
    innerStyle: {
      padding: 9,
      paddingLeft: 16,
      paddingRight: 16,
      minHeight: 280
    },
    titleStyle: {
      fontSize: 32,
      marginBottom: 20
    }
  }
};
var DefaultComponent = function (props) {
  return /*#__PURE__*/React.createElement(PnmacCardContent, null, /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 100
    }
  }, /*#__PURE__*/React.createElement(FadeLoader, {
    size: 200,
    color: "#003187",
    loading: true
  })));
};
var CardContentExtend = function (props) {
  var _a;
  var _b = ((_a = props.layout) === null || _a === void 0 ? void 0 : _a.currentLoan) || {
      customerProperty: []
    },
    unpaidPrincipalBalanceAmount = _b.unpaidPrincipalBalanceAmount,
    currentTotalMonthlyPaymentAmount = _b.currentTotalMonthlyPaymentAmount,
    originalNextPaymentDueDate = _b.originalNextPaymentDueDate,
    currentInterestRate = _b.currentInterestRate,
    nextPaymentDueDate = _b.nextPaymentDueDate;
  var matches = props.matches;
  var translations = props.translations;
  var firstFrontSection = function (matches) {
    var _a, _b, _c, _d;
    var layout = props.layout;
    var status = (_a = layout.selectedLoanAvailability) === null || _a === void 0 ? void 0 : _a.status;
    var paymentModel = layout.paymentModel;
    var enableDelinquent = !getActiveFeatures(layout.features, "BRMS_Delinquent", false) ? !((_b = paymentStatus(status, "current", ["2PaymentsPastDue"])) === null || _b === void 0 ? void 0 : _b.hasSubStatus) : !((_d = (_c = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _c === void 0 ? void 0 : _c.delinquentPayments) === null || _d === void 0 ? void 0 : _d.length) > 0;
    if (phazOne(status)) {
      return null;
    }
    return enableDelinquent ? /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1,
        paddingRight: matches.small ? 20 : "initial"
      }
    }, /*#__PURE__*/React.createElement(PnmacTitle, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 18 : 24,
        fontWeight: "bold"
      })
    }, currencyFormatter('en-US', 'currency', 'USD', currentTotalMonthlyPaymentAmount)), /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({}, textStyle.defaultTextDescription), {
        fontSize: matches.Small ? 9 : 14
      })
    }, translations === null || translations === void 0 ? void 0 : translations.NextPaymentDue), /*#__PURE__*/React.createElement(PnmacText, {
      style: __assign(__assign({}, textStyle.defaultTextDescription), {
        fontSize: matches.Small ? 9 : 14
      })
    }, moment(originalNextPaymentDueDate || nextPaymentDueDate).format("MM/DD/YYYY"))) : null;
  };
  return /*#__PURE__*/React.createElement(PnmacCardContent, {
    style: {
      paddingTop: 6
    }
  }, /*#__PURE__*/React.createElement(PnmacCardActions, {
    style: {
      width: '100%',
      display: 'flex',
      paddingLeft: matches.small ? 0 : "initial",
      paddingBottom: matches.small ? 20 : 2,
      flexDirection: matches.small ? 'column' : 'row',
      alignItems: "flex-start",
      justifyContent: "space-between"
    }
  }, firstFrontSection(matches), /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(PnmacTitle, {
    style: __assign(__assign({}, textStyle.defaultTextTitle), {
      paddingLeft: matches.small ? 0 : 20,
      fontSize: firstFrontSection(matches) && matches.small ? 18 : 24,
      fontWeight: "bold"
    })
  }, currencyFormatter('en-US', 'currency', 'USD', unpaidPrincipalBalanceAmount === null || unpaidPrincipalBalanceAmount === void 0 ? void 0 : unpaidPrincipalBalanceAmount.toString())), /*#__PURE__*/React.createElement(PnmacText, {
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      paddingLeft: matches.small ? 0 : 20,
      fontSize: 14
    })
  }, translations === null || translations === void 0 ? void 0 : translations.CurrentLoanBalance)), /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(PnmacTitle, {
    style: __assign(__assign({}, textStyle.defaultTextTitle), {
      paddingLeft: matches.small ? 0 : 25,
      fontSize: firstFrontSection(matches) && matches.small ? 18 : 24,
      fontWeight: "bold"
    })
  }, percentFormatter('en-US', 'percent', currentInterestRate)), /*#__PURE__*/React.createElement(PnmacText, {
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      paddingLeft: matches.small ? 0 : 25,
      fontSize: 14
    })
  }, translations === null || translations === void 0 ? void 0 : translations.CurrentInterestRate)), /*#__PURE__*/React.createElement(View, {
    style: __assign(__assign({}, firstFrontSection(matches) || props.layout.mobile ? {
      display: 'none'
    } : {
      display: 'unset'
    }), {
      visibility: 'hidden',
      width: '33%',
      height: '33%'
    })
  })));
};
var CardContentExtendDeliquint = function (props) {
  var _a, _b, _c;
  var unpaidPrincipalBalanceAmount = (((_a = props.layout.loanArray) === null || _a === void 0 ? void 0 : _a.find(function (s) {
    return s.loanId == props.layout.selectedLoanNumber;
  })) || {
    customerProperty: []
  }).unpaidPrincipalBalanceAmount;
  var matches = props.matches,
    layout = props.layout,
    translations = props.translations;
  var status = (_b = layout.selectedLoanAvailability) === null || _b === void 0 ? void 0 : _b.status;
  var isModPortalVisible = layout.modPortalVisible;
  var firstFrontSection = function (matches) {
    return !isModPortalVisible ? /*#__PURE__*/React.createElement(View, {
      style: {
        width: matches.small ? "100%" : '33%'
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        width: '100%',
        marginTop: 20,
        marginBottom: 20
      }
    }, /*#__PURE__*/React.createElement(PnmacTitle, {
      style: __assign(__assign({}, textStyle.defaultTextTitle), {
        fontSize: matches.small ? 18 : 24,
        fontWeight: "bold"
      })
    }, currencyFormatter('en-US', 'currency', 'USD', unpaidPrincipalBalanceAmount === null || unpaidPrincipalBalanceAmount === void 0 ? void 0 : unpaidPrincipalBalanceAmount.toString())), /*#__PURE__*/React.createElement(PnmacText, {
      idTag: "btnCntLoanBal",
      style: __assign(__assign({}, textStyle.defaultTextDescription), {
        fontSize: 14
      })
    }, translations === null || translations === void 0 ? void 0 : translations.CurrentLoanBalance))) : isModPortalVisible ? /*#__PURE__*/React.createElement(View, {
      style: {
        width: '30%'
      }
    }) : null;
  };
  return /*#__PURE__*/React.createElement(PnmacCardContent, null, /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: matches.small ? "column" : "row",
      justifyContent: "space-between",
      alignItems: matches.small ? "flex-start" : "center",
      minHeight: 90,
      marginTop: matches.small ? 10 : "initial"
    }
  }, firstFrontSection(matches), /*#__PURE__*/React.createElement(PnmacCard, {
    elvation: 0,
    style: {
      display: "flex",
      width: matches.small ? '98%' : '60%',
      marginTop: matches.small ? 0 : -35,
      marginBottom: matches.small ? 20 : 0,
      padding: 15
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      width: '20%'
    }
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    style: {
      color: "#ff4500",
      marginBottom: 10,
      fontSize: matches.small ? "35" : "45"
    }
  })), genericStatusCheck(status, "modification", []).hasStatus && isModPortalVisible ? /*#__PURE__*/React.createElement(View, {
    style: {
      width: '75%'
    }
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
    style: textStyle.defaultTextDescription
  }, translations === null || translations === void 0 ? void 0 : translations.LoanMessage1)), /*#__PURE__*/React.createElement(View, {
    style: {
      marginTop: 10,
      fontSize: 14
    }
  }, /*#__PURE__*/React.createElement(PnmacText, null, translations === null || translations === void 0 ? void 0 : translations.LoanMessage2))) : /*#__PURE__*/React.createElement(View, {
    style: {
      width: '75%'
    }
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
    style: textStyle.defaultTextDescription
  }, translations === null || translations === void 0 ? void 0 : translations.LoanCallMessage2), /*#__PURE__*/React.createElement(PnmacText, {
    style: {
      fontWeight: '900'
    }
  }, (_c = layout.translations) === null || _c === void 0 ? void 0 : _c.CallInNumber)))))));
};
var PaymentTileLanding = /** @class */function (_super) {
  __extends(PaymentTileLanding, _super);
  function PaymentTileLanding(props) {
    var _this = _super.call(this, props) || this;
    _this.buttonProps = function (route) {
      var _a;
      var _b = _this.props,
        layout = _b.layout,
        matches = _b.matches;
      var action = "";
      var enabled = ((_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.loanId) > 0;
      return {
        hoverColor: "#fff",
        uppercase: false,
        disabled: !enabled,
        style: {
          borderColor: "#003087",
          borderWidth: 1,
          shadowColor: 'white',
          alignItems: 'center',
          backgroundColor: "#cce9f5",
          marginHorizontal: 4,
          padding: 0,
          marginBottom: 0,
          marginTop: Platform.OS === 'web' ? 0 : 10
        },
        onPress: function () {
          var _a;
          switch (route) {
            case 'Loan':
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Loan Information Button Clicked", 1);
              action = "LoanSummary";
              break;
            case 'Mod':
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Mortgage Center Button Clicked", 1);
              action = "Mod";
              break;
            case 'Payment':
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Make Payment Button Clicked", 1);
              action = "Payment";
              break;
            case 'StatementsAndDocuments':
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "View Statements Button Clicked", 1);
              action = "StatementsAndDocuments";
              break;
            case 'Loan/Activity':
              action = "LoanActivity";
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Loan Activity Servicing Button Clicked", 1);
              break;
            default:
          }
          if (action == "Payment" && Platform.OS != 'web') {
            (_a = _this.props) === null || _a === void 0 ? void 0 : _a.navigation.navigate('PaymentsBTN', {
              screen: 'PaymentsBTN',
              initial: false
            });
          } else {
            PnmacNavigation(__assign({
              action: {
                pathname: "/".concat(route)
              }
            }, _this.props));
          }
        }
      };
    };
    _this.getbutton = function () {
      var _a;
      var _b = _this.props,
        layout = _b.layout,
        translations = _b.translations,
        matches = _b.matches;
      var isModPortalVisible = layout.modPortalVisible;
      var makeApPayment = (_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.canMakePayment;
      if (isModPortalVisible) {
        return /*#__PURE__*/React.createElement(View, {
          style: Platform.select({
            web: {
              width: matches.small ? "90%" : "initial",
              flex: 1
            },
            default: {
              width: '100%'
            }
          })
        }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({}, _this.buttonProps("Mod")), /*#__PURE__*/React.createElement(PnmacText, {
          idTag: "btnMtgCenter",
          adjustsFontSizeToFit: true,
          style: {
            fontFamily: "Montserrat",
            fontSize: 13,
            fontWeight: "bold",
            textTransform: 'uppercase'
          }
        }, translations === null || translations === void 0 ? void 0 : translations.MortgageCenter), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "CaretRight icon", 'xml')));
      } else if (!makeApPayment) {
        return /*#__PURE__*/React.createElement(View, {
          style: Platform.select({
            web: {
              width: matches.small ? "90%" : "initial",
              flex: 1
            },
            default: {
              width: '100%'
            }
          })
        }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({}, _this.buttonProps("Loan")), /*#__PURE__*/React.createElement(PnmacText, {
          idTag: "btnLoanInfo",
          adjustsFontSizeToFit: true,
          style: {
            fontFamily: "Montserrat",
            fontSize: 13,
            fontWeight: "bold",
            textTransform: 'uppercase'
          }
        }, translations === null || translations === void 0 ? void 0 : translations.LoanInformation), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "CaretRight icon", 'xml')));
      } else {
        return /*#__PURE__*/React.createElement(View, {
          style: Platform.select({
            web: {
              width: matches.small ? "90%" : "initial",
              flex: 1
            },
            default: {
              width: '100%'
            }
          })
        }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({}, _this.buttonProps(layout.mobile ? "PaymentsBTN" : "Payment")), /*#__PURE__*/React.createElement(PnmacText, {
          idTag: "btnMakePayment",
          adjustsFontSizeToFit: true,
          style: {
            fontFamily: "Montserrat",
            fontSize: 13,
            fontWeight: "bold",
            textTransform: 'uppercase'
          }
        }, translations === null || translations === void 0 ? void 0 : translations.MakeaPayment), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "CaretRight icon", 'xml')));
      }
    };
    _this.state = {
      endValue: 1,
      duration: 5000
    };
    return _this;
  }
  PaymentTileLanding.prototype.render = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var _o = this.props,
      matches = _o.matches,
      layout = _o.layout,
      translations = _o.translations;
    var loan = layout.currentLoan;
    var makeApPayment = (_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.canMakePayment;
    var status = (_b = layout.selectedLoanAvailability) === null || _b === void 0 ? void 0 : _b.status;
    var defaultPayments = (_c = layout.currentLoan) === null || _c === void 0 ? void 0 : _c.defaultPayments;
    var tiles = defaultPayments != null && ((_d = defaultPayments === null || defaultPayments === void 0 ? void 0 : defaultPayments.route) === null || _d === void 0 ? void 0 : _d.toLowerCase()) == "delinquent" && !getActiveFeatures(layout.features, "BRMS_Delinquent", false) || defaultPayments != null && ((_e = defaultPayments === null || defaultPayments === void 0 ? void 0 : defaultPayments.route) === null || _e === void 0 ? void 0 : _e.toLowerCase()) == "default" && !getActiveFeatures(layout.features, "BRMS_LossMit", false) ? /*#__PURE__*/React.createElement(CardContentExtendDeliquint, __assign({
      buttonProps: this.buttonProps
    }, this.props)) : defaultPayments != null && ((_f = defaultPayments === null || defaultPayments === void 0 ? void 0 : defaultPayments.route) === null || _f === void 0 ? void 0 : _f.toLowerCase()) == "delinquent" && getActiveFeatures(layout.features, "BRMS_Delinquent", false) || defaultPayments != null && ((_g = defaultPayments === null || defaultPayments === void 0 ? void 0 : defaultPayments.route) === null || _g === void 0 ? void 0 : _g.toLowerCase()) == "default" && getActiveFeatures(layout.features, "BRMS_LossMit", false) ? /*#__PURE__*/React.createElement(CardContentExtend, __assign({
      buttonProps: this.buttonProps
    }, this.props)) : !makeApPayment && !((_h = genericStatusCheck(status, "completedTwo", [])) === null || _h === void 0 ? void 0 : _h.hasStatus) || ((_j = genericStatusCheck(status, "modification", [])) === null || _j === void 0 ? void 0 : _j.hasStatus) ? /*#__PURE__*/React.createElement(CardContentExtendDeliquint, __assign({
      buttonProps: this.buttonProps
    }, this.props)) : /*#__PURE__*/React.createElement(CardContentExtend, __assign({
      buttonProps: this.buttonProps
    }, this.props));
    return /*#__PURE__*/React.createElement(View, {
      style: {
        flexGrow: 3,
        flexBasis: matches.large ? "57%" : "100%",
        padding: styles.card.padding,
        flexShrink: 3
      }
    }, /*#__PURE__*/React.createElement(PnmacCard, {
      nativeID: "cdMyMortgage",
      elvation: 0,
      style: Platform.select({
        web: {
          paddingHorizontal: 12,
          paddingVertical: 9,
          minHeight: 280,
          backgroundColor: "#d2e9f4"
        },
        default: {
          paddingHorizontal: 12,
          paddingVertical: 9,
          minHeight: 280,
          backgroundColor: "#d2e9f4"
        }
      })
    }, loan && (layout === null || layout === void 0 ? void 0 : layout.modLoaded) && (layout === null || layout === void 0 ? void 0 : layout.paymentModel) || loan && ((_k = layout.currentLoan) === null || _k === void 0 ? void 0 : _k.helocFlag) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacCardTitle, {
      titleStyle: {
        fontWeight: "bold",
        fontSize: !matches.small ? 24 : 20
      },
      title: translations === null || translations === void 0 ? void 0 : translations.MyMortgage,
      subtitleStyle: {
        fontSize: 18,
        fontWeight: "bold"
      },
      right: function () {
        return PnmacImage(layout.mobile ? "myMortgage" : require("../assets/my-mortgage.svg"), matches.small ? 40 : 65, "Cash icon", 'css');
      }
    }), /*#__PURE__*/React.createElement(View, {
      style: Platform.select({
        web: {
          minHeight: 125
        },
        default: {
          minHeight: 125
        }
      })
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: {
        fontFamily: "Montserrat",
        padding: 0,
        paddingLeft: 17,
        fontSize: 16,
        fontWeight: "bold"
      }
    }, translations === null || translations === void 0 ? void 0 : translations.LoanEnding, " - ", (_l = loan === null || loan === void 0 ? void 0 : loan.loanId) === null || _l === void 0 ? void 0 : _l.toString().substr(((_m = loan === null || loan === void 0 ? void 0 : loan.loanId) === null || _m === void 0 ? void 0 : _m.length) - 4)), tiles), /*#__PURE__*/React.createElement(PnmacCardActions, {
      style: Platform.select({
        web: {
          flex: 1,
          display: 'flex',
          marginTop: 0,
          flexDirection: matches.small ? 'column' : 'row',
          alignItems: "center",
          justifyContent: "space-between"
        },
        default: {
          flex: 1,
          marginTop: 10,
          flexDirection: 'column',
          alignItems: "center",
          justifyContent: "space-between"
        }
      })
    }, this.getbutton(), /*#__PURE__*/React.createElement(View, {
      style: Platform.select({
        web: {
          width: matches.small ? "90%" : "initial",
          flex: 1,
          paddingTop: matches.small ? 10 : 0
        },
        default: {
          width: '100%'
        }
      })
    }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({}, this.buttonProps("StatementsAndDocuments")), /*#__PURE__*/React.createElement(PnmacText, {
      idTag: "btnViewStatement",
      style: {
        fontFamily: "Montserrat",
        fontSize: 13,
        fontWeight: "bold",
        textTransform: 'uppercase'
      }
    }, translations === null || translations === void 0 ? void 0 : translations.ViewStatements), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "CaretRight icon", 'xml'))), /*#__PURE__*/React.createElement(View, {
      style: Platform.select({
        web: {
          width: matches.small ? "90%" : "initial",
          flex: 1,
          paddingTop: matches.small ? 10 : 0
        },
        default: {
          width: '100%'
        }
      })
    }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({}, this.buttonProps("Loan/Activity")), /*#__PURE__*/React.createElement(PnmacText, {
      idTag: "btnViewLoanActivity",
      adjustsFontSizeToFit: true,
      style: {
        fontFamily: "Montserrat",
        fontSize: 13,
        fontWeight: "bold",
        textTransform: 'uppercase'
      }
    }, translations === null || translations === void 0 ? void 0 : translations.ViewLoanActivity), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "CaretRight icon", 'xml'))))) : layout.mobile && !(layout === null || layout === void 0 ? void 0 : layout.pennyWise) ? /*#__PURE__*/React.createElement(PnmacWelcomeLoader, {
      containerStyles: {
        paddingTop: 20,
        borderRadius: 10
      },
      translations: translations
    }) : /*#__PURE__*/React.createElement(DefaultComponent, null)));
  };
  return PaymentTileLanding;
}(React.Component);
export default PaymentTileLanding;